import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { ref: "refEl" }
const _hoisted_2 = {
  key: 0,
  class: "menu"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  class: "internal-container",
  tabindex: "-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["TableauTextBox"], {
      modelValue: $setup.value,
      label: $props.label,
      placeholder: $props.placeholder,
      disabled: $props.disabled,
      onFocus: _cache[0] || (_cache[0] = ($event: any) => ($setup.setOpen(true))),
      onBlur: _cache[1] || (_cache[1] = ($event: any) => ($setup.onBlur())),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.updateValue($event)))
    }, null, 8 /* PROPS */, ["modelValue", "label", "placeholder", "disabled"]),
    _createElementVNode("div", _hoisted_1, null, 512 /* NEED_PATCH */),
    ($setup.menuOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "root",
            style: _normalizeStyle($setup.overlayStyle),
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.setOpen(false)))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                ($setup.menuOptions.topText)
                  ? (_openBlock(), _createBlock($setup["TableauSelectButton"], {
                      key: 0,
                      disabled: "",
                      isLoading: $setup.menuOptions.isLoading,
                      text: $setup.menuOptions.topText
                    }, null, 8 /* PROPS */, ["isLoading", "text"]))
                  : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredItems, (i) => {
                  return (_openBlock(), _createBlock($setup["TableauSelectButton"], {
                    key: i,
                    onClicked: ($event: any) => ($setup.updateValue(i)),
                    text: i
                  }, null, 8 /* PROPS */, ["onClicked", "text"]))
                }), 128 /* KEYED_FRAGMENT */)),
                ($setup.menuOptions.bottomText)
                  ? (_openBlock(), _createBlock($setup["TableauSelectButton"], {
                      key: 1,
                      disabled: "",
                      text: $setup.menuOptions.bottomText
                    }, null, 8 /* PROPS */, ["text"]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ], 4 /* STYLE */)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}